import { arrayOf, func, object } from 'prop-types';
import React from 'react';
import { path } from 'ramda';

import ActionButton from 'components/ActionButton';
import ContentColumns from '../components/ContentColumns';

import View1 from './Views/View1';
import View2 from './Views/View2';

class Rehabilitation2 extends React.Component {
  state = {
    view: 1,
  };

  componentDidMount() {
    const finished = path(['formValues', 'rehab2', 'finished'], this.context);
    // If this session is finished, navigate to last view
    if (finished) this.setState({ view: 2 });
  }

  advanceView = () => {
    const { setFinished } = this.context;
    if (this.state.view === 1) {
      setFinished();
    }
    this.setState({ view: this.state.view + 1 });
  };

  backView = () => {
    this.setState({ view: this.state.view - 1 });
  };

  render() {
    const { view } = this.state;
    return (
      <div>
        {view === 1 ? <View1 advanceView={this.advanceView} documents={this.props.documents} /> : null}
        {view === 2 ? <View2 advanceView={this.advanceView} documents={this.props.documents} /> : null}
        <ContentColumns
          firstColumn={
            <div style={{ display: 'flex', marginTop: '2rem' }}>
              <div style={{ flex: 1 }}>
                {view > 1 && view < 5 ? (
                  <ActionButton
                    localeId={'onlineRehabilitation.back'}
                    onClick={this.backView}
                    style={{ width: '15rem' }}
                    secondary
                  />
                ) : null}
              </div>
              {view !== 2 && (
                <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                  <ActionButton
                    localeId={view === 8 ? 'onlineRehabilitation.send' : 'onlineRehabilitation.advance'}
                    onClick={this.advanceView}
                    style={{ width: '15rem' }}
                    filledSecondary
                  />
                </div>
              )}
            </div>
          }
        />
      </div>
    );
  }
}

Rehabilitation2.contextTypes = { setFinished: func, formValues: object };
Rehabilitation2.propTypes = { documents: arrayOf(object) };

export default Rehabilitation2;
